import React, { useEffect, useState } from 'react'
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getStateAndRoute } from '../service/WfhAPI';
import Loader from '../StaticComponent/Loader';


export default function NotificationCall() {

    const { NotificationId } = useParams()
    const navigate = useNavigate();


    useEffect(() => {

        if (NotificationId) {
            loadStateAndRoute(NotificationId);
        }

    }, [])

    const loadStateAndRoute = async (id) => {

        let response = await getStateAndRoute({ notificationId: id });
        let state = response.data.ResponseData[0].state;
        let route = response.data.ResponseData[0].route;
        let title = response.data.ResponseData[0].title;

        notificationClick(route, state, title);

    }

    const notificationClick = async (route, state, title) => {

        if (title === 'Profile Update' || title === 'Offboard' || title === 'Feedback') {
            window.location.href = route;
        } else {

            if (state) {
                navigate(route, state)
            }
            else {
                navigate(route)
            }
        }

    }



    return (
        <div>
            <Loader isLoading={false} />
        </div>
    );

}